"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EChainStatus;
(function (EChainStatus) {
    EChainStatus["ACTIVE"] = "ACTIVE";
    EChainStatus["NOT_ACTIVE"] = "NOT_ACTIVE";
})(EChainStatus = exports.EChainStatus || (exports.EChainStatus = {}));
var EOnboardingMilestoneStatus;
(function (EOnboardingMilestoneStatus) {
    EOnboardingMilestoneStatus["COMPLETE"] = "COMPLETE";
    EOnboardingMilestoneStatus["TODO"] = "TODO";
})(EOnboardingMilestoneStatus = exports.EOnboardingMilestoneStatus || (exports.EOnboardingMilestoneStatus = {}));
var EAdminTaskStatus;
(function (EAdminTaskStatus) {
    EAdminTaskStatus["TODO"] = "TODO";
    EAdminTaskStatus["COMPLETE"] = "COMPLETE";
})(EAdminTaskStatus = exports.EAdminTaskStatus || (exports.EAdminTaskStatus = {}));
var EAdminTaskAction;
(function (EAdminTaskAction) {
    EAdminTaskAction["RESCHEDULED"] = "RESCHEDULED";
    EAdminTaskAction["CREATED"] = "CREATED";
    EAdminTaskAction["EDITED"] = "EDITED";
    EAdminTaskAction["COMPLETED"] = "COMPLETED";
    EAdminTaskAction["COMMENT"] = "COMMENT";
})(EAdminTaskAction = exports.EAdminTaskAction || (exports.EAdminTaskAction = {}));
